import { formatDateToMMDDYYYY } from '@gripp/shared-logic';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Text, View } from 'react-native';
import { formStyles } from '../../styles/forms';
import { DatePickerSelector } from '../forms';

type CreatedDateFieldProps = {
  createdAt: string;
};

export const CreatedDateField = ({
  createdAt,
}: CreatedDateFieldProps) => {
  const { t } = useTranslation();

  const formattedDate = createdAt ? formatDateToMMDDYYYY(createdAt) : '';

  const { control, setValue } = useForm({
    values: { createdAtDisplay: formattedDate },
  });

  return (
    <>
      <View>
        <Text style={formStyles.formItemTitle}>
          {t('issue.createdDate.header')}
        </Text>
      </View>
      <DatePickerSelector
        name="createdAtDisplay"
        setValue={setValue}
        control={control}
        label=""
        placeholder={t('issue.dateFormat')}
        disabled
      />
    </>
  );
};
